// Module
var code = " <div class=\"react-container react-zoom\"> <pricing-page/> </div> ";
// Exports
module.exports = code;